import { GetTripOfferRequestsForAdminState } from './getTripOfferRequestsForAdmin.types'

const initialState: GetTripOfferRequestsForAdminState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
